import type { StripeCheckoutSubmission } from '../../../../components/StripeCheckout';
import type { StripeCheckoutParams } from '../../../../lib/authentication';
import { parseStripeAddressName } from '../../../../lib/nameParser';

export type StripeCheckoutBodySource = Pick<
  StripeCheckoutSubmission,
  'tokenId' | 'email' | 'address' | 'chargedInline' | 'isIdentityVerified' | 'billingAddress'
>;

export function stripeCheckoutBody(
  params: StripeCheckoutBodySource,
  tenancy: string | undefined,
  threeDSecureActionResultToken?: string,
): StripeCheckoutParams {
  const { tokenId, email, address } = params;
  // on a ship-to-recipient gift the form address is the recipient's; the account and analytics take the buyer's name
  const { firstName, lastName } = parseStripeAddressName(params.billingAddress ?? address);
  return {
    // a payment-mode token is omitted here so the backend does not store it as billing info;
    // it is charged inline at the purchase mutation instead.
    confirmationToken: params.chargedInline ? undefined : tokenId,
    // wallets only: klarna's inline token has the typed form email, not a wallet-verified one
    verificationToken: params.chargedInline && params.isIdentityVerified ? tokenId : undefined,
    email,
    firstName,
    lastName,
    address1: address.address.line1,
    address2: address.address.line2 ?? undefined,
    city: address.address.city,
    state: address.address.state,
    // web rejects an empty string as a phone; an unset phone is optional
    phone: address.phone || undefined,
    zip: address.address.postal_code,
    country: address.address.country,
    tenancy,
    threeDSecureActionResultToken,
    ...(params.billingAddress && { billingAddressOnToken: true }),
  };
}
